import MainLayout from "../../layout/MainLayout";
import DataTable from "../../common/Tables/DataTable";
import { actionPost, useApiCall } from "../../services/api";
import useExpiredToken from "../../utils/useExpiredToken";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getAssignedQAColumns, ShowData } from "../../utils/ShowData";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../utils/Toast";
import AuditType from "../../components/models/AuditType";
import { processEncryptedResponse } from "../../utils/ResponseDecreypt";
import AssignedCallDetails from "../../components/models/AssignedCallDetails";
import { filterDataFunc, qaTypeButtons, roleNames } from "../../constant";
import FilterSection from "../../components/FilterSection";
import AppSelect from "../../common/FormInputs/AppSelect";
import { Button, Dropdown, Space, Tag } from "antd";
import {
  DeleteOutlined,
  DownloadOutlined,
  EllipsisOutlined,
  EyeOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import DateRangeFilter from "../../components/filters/DateRangeFilter";
import dayjs from "dayjs";

const AuditedCalls = () => {
  const [data, setData] = useState([]);
  const token = useSelector((state) => state.auth.jwtToken);
  const expireToken = useExpiredToken();
  const { callApi } = useApiCall();
  const role = useSelector((state) => state.auth.role);
  const { searchText } = useSelector((state) => state.search);
  const [deleteData, setDeleteData] = useState({});
  const navigate = useNavigate();
  const toast = useToast();
  const [isAudit, setIsAudit] = useState(false);
  const [auditType, setAuditType] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [qaList, setQAList] = useState([]);
  const [selectedQA, setSelectedQA] = useState(null);

  const handleCancel = () => {
    setIsAudit(false);
    setIsDetailsModalOpen(false);
  };

  // const fetchData = async () => {
  //   const res = await actionPost("calls/summary", token, "AUDITED_CALLS", {}, expireToken);
  //   const data = await processEncryptedResponse(res);
  //   if (data) {
  //     setData(data);
  //   }
  // };

  const mappedData = data?.map((item, index) => ShowData(item, role, index));
  const filteredData = filterDataFunc(mappedData, searchText);

  const handleAuditCall = (record) => {
    setDeleteData(record?.originalItem);
  };

  const fetchAllQA = async () => {
    const { decrypted, status } = await callApi({
      endpoint: "superadmin/users/qa/dynamic",
      queryParams: {
        qaId: selectedQA,
      },
      showToast: false,
    });

    if (status) {
      const mappedQAList = decrypted?.users?.map((qa) => ({
        label: `${qa.full_name} (${qa.email})`,
        value: qa.username,
      }));
      setQAList(mappedQAList);
    }
  };

  // useEffect(() => {
  //   fetchAllQA();
  // }, []);

  // useEffect(() => {
  //   fetchData();
  // }, [selectedQA]);

  const handleRedirect = (type) => {
    if (type == "back") {
      setIsAudit(false);
    } else {
      if (auditType) {
        navigate(`/audit-details/${deleteData?.id}`, {
          state: { record: deleteData, auditType },
        });
      } else {
        toast.error("Audit type not selected!");
      }
    }
  };

  const auditTypeOptions =
    deleteData?.assigned_users?.audit_types
      ?.filter((item) => item?.status === false)
      ?.map((item) => ({
        label: item?.audit_type_name,
        value: item?.audit_type_id,
      })) || [];

  const handleView = (record) => {
    setSelectedRow(record);
    setIsDetailsModalOpen(true);
  };

  const columns = [
    {
      title: "Call ID",
      dataIndex: "Call ID",
      key: "Call ID",
      width: 100,
    },
    {
      title: "Call date",
      dataIndex: "Call date",
      key: "Call date",
      width: 134,
    },
    // {
    //   title: "Start time",
    //   dataIndex: "Start time",
    //   key: "Start time",
    //   width: 134,
    // },
    // {
    //   title: "End time",
    //   dataIndex: "End time",
    //   key: "End time",
    //   width: 134,
    // },
    {
      title: "Agency name",
      dataIndex: "Agency name",
      key: "Agency name",
      width: 134,
    },
    {
      title: "Call duration",
      dataIndex: "Call duration",
      key: "Call duration",
    },
    {
      title: "Call type",
      dataIndex: "Call type",
      key: "Call type",
      width: 134,
    },
    {
      title: "Agent ID",
      dataIndex: "Agent ID",
      key: "Agent ID",
      width: 134,
    },
    {
      title: "Disconnected by",
      dataIndex: "Disconnected by",
      key: "Disconnected by",
      filters: [
        { text: "Customer", value: "CUSTOMER" },
        { text: "Agent", value: "AGENT" },
      ],
      onFilter: (value, record) => value && record["Disconnected by"] === value,
    },
    {
      title: "Disposition",
      dataIndex: "Disposition",
      key: "Disposition",
      width: 350,
    },
    role !== roleNames.qa && {
      title: "Assigned QA",
      key: "assigned_user",
      render: (_, record) => {
        const user = record?.originalItem?.assigned_user;
        return (
          <Tag key={user.user_id} color="geekblue">
            {user.username} - ({user?.audit_type_name})
          </Tag>
        );
      },
    },
    {
      dataIndex: "assigned_users_text",
      key: "assigned_users_text",
      hidden: true,
    },
    {
      title: "Call status",
      dataIndex: "Call status",
      key: "Call status",
      render: (status) => <Tag color={status === "COMPLETED" ? "green" : "red"}>{status}</Tag>,
      filters: [
        { text: "COMPLETED", value: "COMPLETED" },
        { text: "PENDING", value: "PENDING" },
      ],
      onFilter: (value, record) => record["Call status"] === value,
    },
    {
      title: "Customer phone number",
      dataIndex: "Customer phone number",
      key: "Customer phone number",
    },
    {
      title: "Audit Type",
      key: "assigned_users",
      render: (_, record) => {
        const auditType = record?.originalItem?.assigned_user;

        return (
          auditType && (
            <Tag key={auditType.audit_type_id} color="geekblue">
              {auditType.audit_type_name}
            </Tag>
          )
        );
      },
      filters: qaTypeButtons.map((item) => ({ text: item.label, value: item.id })),
      onFilter: (value, record) => record?.originalItem?.assigned_user?.audit_type_id === value,
    },
    {
      title: "Audited At",
      render: (_, record) => {
        const auditedAt = record?.originalItem?.updated_at;
        return auditedAt ? dayjs(auditedAt).format("YYYY-MM-DD HH:mm:ss") : "-";
      },
    },
    {
      title: "Action",
      key: "Action",
      render: (_, record) => (
        <Button
          icon={<DownloadOutlined />}
          onClick={() => {
            const width = window.screen.availWidth;
            const height = window.screen.availHeight;

            window.open(
              `/report-pdf?callId=${record.id}&auditTypeId=${record?.originalItem?.assigned_user?.audit_type_id}`,
              "_blank",
              `width=${width},height=${height},left=0,top=0`
            );
          }}
          //   onClick={() => {
          //     setSelectedRow(record);
          //     setIsAuditTypeModalOpen(true);
          //   }}
        >
          Download
        </Button>
      ),
    },
  ].filter(Boolean);

  return (
    <>
      <>
        <div className="container-fluid">
          {/* <div className="">
            <FilterSection />
          </div> */}
          {/* QA filter */}
          {/* <div className="pb-3 col-12 col-sm-3">
            <AppSelect
              label=""
              name="batch_number"
              type="text"
              placeholder="Select QA"
              options={qaList}
              value={selectedQA}
              rules={[{ required: true, message: "Please select the item!" }]}
              onChange={handleOnChange}
              allowClear
            />
          </div> */}
          <DataTable
            updatedColumns={columns}
            callApiArgs={{
              endpoint: "calls/summary",
              bodyData: {
                action: "AUDITED_CALLS",
                input: {},
              },
              apiMethod: "post",
            }}
          />
        </div>
      </>
      <AuditType
        handleCancel={handleCancel}
        open={isAudit}
        handleBack={handleRedirect}
        auditType={auditType}
        setAuditType={setAuditType}
        auditTypeOptions={auditTypeOptions}
      />

      <AssignedCallDetails
        open={isDetailsModalOpen}
        handleCancel={handleCancel}
        formData={selectedRow}
      />
    </>
  );
};

export default AuditedCalls;
